import { ACTIONS_TYPES } from "../utils/constants";


export function fetchCompaniesRequest() {
  return {
    type: ACTIONS_TYPES.FETCH_COMPANIES_REQUEST,
  }
}

export function fetchCompaniesSuccess(response) {
  return {
    type: ACTIONS_TYPES.FETCH_COMPANIES_SUCCESS,
    payload: response,
  }
}

export function fetchCompaniesFailed(response) {
  return {
    type: ACTIONS_TYPES.FETCH_COMPANIES_FAILED,
    payload: response,
  }
}
export function registerCompanyRequest(payload) {
  return {
    type: ACTIONS_TYPES.REGISTER_COMPANY_REQUEST,
    payload
  }
}

export function registerCompanySuccess(response) {
  return {
    type: ACTIONS_TYPES.REGISTER_COMPANY_SUCCESS,
    payload: response,
  }
}

export function registerCompanyFailed(response) {
  return {
    type: ACTIONS_TYPES.REGISTER_COMPANY_FAILED,
    payload: response,
  }
}

export function registerCompanyReset() {
  return {
    type: ACTIONS_TYPES.REGISTER_COMPANY_RESET,
  }
}

export function suspendCompanyRequest(payload) {
  return {
    type: ACTIONS_TYPES.SUSPEND_COMPANY_REQUEST,
    payload
  }
}

export function suspendCompanySuccess(response) {
  return {
    type: ACTIONS_TYPES.SUSPEND_COMPANY_SUCCESS,
    payload: response,
  }
}

export function suspendCompanyFailed(response) {
  return {
    type: ACTIONS_TYPES.SUSPEND_COMPANY_FAILED,
    payload: response,
  }
}

export function SuspendCompanyReset() {
  return {
    type: ACTIONS_TYPES.SUSPEND_COMPANY_RESET,
  }
}